export default "__VITE_ASSET__f6c4504b__"